import { ProcessedDocumentChunkModel } from "./ProcessedDocumentChunkModel";
import { ProcessedDocumentRiskModel } from "./ProcessedDocumentRiskModel";
import { ProcessedDocumentDocumentModel } from "./ProcessedDocumentDocumentModel";

export class ProcessedDocumentDetailModel {
    id: number;
    title: string;
    document: ProcessedDocumentDocumentModel;
    workflowStatus: ProcessedDocumentWorkflowStatus;
    risks: ProcessedDocumentRiskModel[];
    chunks: ProcessedDocumentChunkModel[];
}

export enum ProcessedDocumentWorkflowStatus {
    none = 0,
    selecting = 1,
    refining = 2,
    completed = 3,
    completedNoSuggestions = 4,
}
